//
//
//
//
//
//
//
//
//
//

export default {
    props: {
        img_path: String,
        link: String,
        log: String,
        building_id: [Number, String],
        width: {
            type: Number,
            default: 343
        },
        height: {
            type: Number,
            default: 44
        }
    },
    computed: {
        style() {
            return {
                width: `${this.width}px`,
                height: `${this.height}px`
            }
        }
    },
    methods: {
        tapImg() {
            if(this.building_id && this.log){
                this.$sendCtmEvtLog(this.log,{building_id: this.building_id})
            }else if (this.log) {
                this.$sendCtmEvtLog(this.log)
            }
            if (this.link) {
                wx.navigateTo({
                    url: this.link
                })
            }
        }
    }
}
